import React from "react";
import { Tooltip } from "react-tooltip";
import "./style.css";

const escapeSelectorValue = value => {
  if (typeof value !== "string") {
    return "";
  }

  if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
    return CSS.escape(value);
  }

  return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
};

const renderLegacyContent = ({ activeAnchor, content, children, getContent, html, multiline }) => {
  const legacyContent = activeAnchor?.getAttribute("data-tip") ?? content ?? null;
  const nextContent = typeof getContent === "function" ? getContent(legacyContent, activeAnchor) : legacyContent;

  if (typeof html === "string") {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  if (html && typeof nextContent === "string") {
    return <div dangerouslySetInnerHTML={{ __html: nextContent }} />;
  }

  if (nextContent != null) {
    return multiline && typeof nextContent === "string" ? (
      <span style={{ whiteSpace: "pre-line" }}>{nextContent}</span>
    ) : (
      nextContent
    );
  }

  return children ?? null;
};

const ReactTooltip = ({
  anchorSelect,
  backgroundColor,
  children,
  className,
  content,
  effect,
  getContent,
  html,
  id,
  multiline,
  style,
  textColor,
  type,
  variant,
  ...props
}) => {
  const legacyAnchorSelect =
    anchorSelect ||
    (id
      ? `[data-for="${escapeSelectorValue(id)}"], [data-tooltip-id="${escapeSelectorValue(id)}"]`
      : "[data-tip]:not([data-for]):not([data-tooltip-id]), [data-tooltip-content]:not([data-tooltip-id]), [data-tooltip-html]:not([data-tooltip-id])");

  return (
    <Tooltip
      anchorSelect={legacyAnchorSelect}
      className={["fr-tooltip", className].filter(Boolean).join(" ")}
      float={effect === "float"}
      id={id}
      render={({ activeAnchor, content: activeContent }) =>
        renderLegacyContent({
          activeAnchor,
          children,
          content: activeContent ?? content,
          getContent,
          html,
          multiline,
        })
      }
      style={{
        ...(backgroundColor ? { backgroundColor, "--rt-color-dark": backgroundColor } : {}),
        ...(textColor ? { color: textColor } : {}),
        ...style,
      }}
      variant={variant || type}
      {...props}
    />
  );
};

export default ReactTooltip;
